/**
 * Ovulation Calendar
 */
export default class OvulationCalendar {
	constructor() {
		/**
		 * DOM Selectors
		 * @type {{acceptAllLabel: string, ovulationCal: string, acceptLabel: string}}
		 */
		this.DOM = {
			ovulationCal: ".c-ovulation-calendar",
			month: document.querySelectorAll('[data-calendar-area="month"]')[0],
			next: document.querySelectorAll('[data-calendar-toggle="next"]')[0],
			previous: document.querySelectorAll('[data-calendar-toggle="previous"]')[0],
			label: document.querySelectorAll('[data-calendar-label="month"]')[0],
			activeDates: null,
			date: new Date,
			todaysDate: new Date,
		};

		this.ovulationCal = document.querySelector(this.DOM.ovulationCal);
	}

	/**
	 * Init
	 */
	init() {
		if (this.ovulationCal === null) {
			return;
		}
		this.ovulationCalendar();
	}

	/**
	 * Make Ovulation Calendar work
	 */
	ovulationCalendar() {
		var _this = this;

		var pickerOne = new Litepicker({
			element: document.getElementById('c-ovulation-cal-1'),
			inlineMode: true,
			numberOfColumns: 1,
			numberOfMonths: 1,
			lang: "hr-HR",
			buttonText: {
				"apply": "",
				"cancel": "",
				"previousMonth": "<svg width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" fill=\"none\" xmlns=\"https://www.w3.org/2000/svg\"><mask id=\"mask0_0:5677\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"8\" height=\"13\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 0.5L7.5 12.5L0.5 12.5L0.5 0.5L7.5 0.5Z\" fill=\"white\"/></mask><g mask=\"url(#mask0_0:5677)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.91495 12.3082L7.30585 11.9151C7.42793 11.7914 7.49518 11.6268 7.49518 11.4509C7.49518 11.2751 7.42793 11.1103 7.30585 10.9866L2.87728 6.50268L7.31076 2.01357C7.43284 1.89006 7.5 1.72528 7.5 1.54947C7.5 1.37367 7.43284 1.20879 7.31076 1.08518L6.92227 0.692002C6.66964 0.435999 6.25811 0.435999 6.00548 0.692002L0.707929 6.03683C0.585922 6.16034 0.5 6.32493 0.5 6.50229V6.50434C0.5 6.68025 0.586043 6.84483 0.707929 6.96835L5.99112 12.3082C6.1131 12.4319 6.28056 12.4998 6.45419 12.5C6.62791 12.5 6.79306 12.4319 6.91495 12.3082Z\" fill=\"#4A4444\"/></g></svg>",
				"nextMonth": "<svg width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" fill=\"none\" xmlns=\"https://www.w3.org/2000/svg\"><mask id=\"mask0_0:5674\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"8\" height=\"13\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.5 12.5L0.5 0.5H7.5L7.5 12.5H0.5Z\" fill=\"white\"/></mask><g mask=\"url(#mask0_0:5674)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.08505 0.691807L0.69415 1.08488C0.572072 1.20857 0.504818 1.37318 0.504818 1.54906C0.504818 1.72486 0.572072 1.88967 0.69415 2.01338L5.12272 6.49732L0.689236 10.9864C0.567158 11.1099 0.5 11.2747 0.5 11.4505C0.5 11.6263 0.567158 11.7912 0.689236 11.9148L1.07773 12.308C1.33036 12.564 1.74189 12.564 1.99452 12.308L7.29207 6.96317C7.41408 6.83966 7.5 6.67507 7.5 6.49771V6.49566C7.5 6.31975 7.41396 6.15517 7.29207 6.03165L2.00888 0.691807C1.8869 0.568098 1.71944 0.500196 1.54581 0.5C1.37209 0.5 1.20694 0.568098 1.08505 0.691807Z\" fill=\"#4A4444\"/></g></svg>",
				"reset": ""
			},
			setup: function setup(pickerOne) {
				pickerOne.on('selected', function (date1, date2) {
				_this.dateMarking(date1, pickerOne, pickerTwo);
				});
			}
		});
		var pickerTwo = new Litepicker({
			element: document.getElementById('c-ovulation-cal-2'),
			inlineMode: true,
			numberOfColumns: 2,
			numberOfMonths: 4,
			lang: "hr-HR",
			switchingMonths: 1,
			buttonText: {
				"apply": "",
				"cancel": "",
				"previousMonth": "",
				"nextMonth": "",
				"reset": ""
			},
			setup: function setup(pickerTwo) {
				pickerTwo.on('before:click', function (target) {
				pickerTwo.preventClick = true;
				});
			}
		});
		pickerOne.show();
		pickerTwo.show();
	}

	/**
	 * Ovulation Calendar dates marking
	 */
	dateMarking(date1, pickerOne, pickerTwo) {
		// set the same month showing
		pickerTwo.gotoDate(date1); // set the same start day on picker two as is clicked on picker one

		pickerTwo.setDate(date1);
		var lenghtPicker = document.getElementById('ovulationCalendarLenght');
		var ovulationLenght = lenghtPicker.options[lenghtPicker.selectedIndex].value;
		ovulationLenght = parseInt(ovulationLenght);
		var dateWW = date1;
		var dateWorkingWith = dateWW.getDate() + ovulationLenght;
		setTimeout(function () {
			for (var j = 0; j < 11; j++) {
				//
				// period start
				//
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('periodStart');
				} //
				// period late
				//
				// add two days for late period


				dateWorkingWith = dateWW.setDate(dateWW.getDate() + 2);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('periodLate');
				} //
				// pregnancy test
				//
				// substract 4 days (date is on late period +2 currently)


				dateWorkingWith = dateWW.setDate(dateWW.getDate() - 4);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('pregnancyTest');
				} // substract 2 days for first pregnancy test (date is on pregnancy test -2 currently)


				dateWorkingWith = dateWW.setDate(dateWW.getDate() - 2);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('pregnancyTest');
				} //
				// ovulation day
				//
				// add ovulation lenght days and then substract 14 days to get to ovulation day


				dateWorkingWith = dateWW.setDate(dateWW.getDate() + ovulationLenght + 4 - 14);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('ovulationDay');
				} //
				// very fertile days
				//
				// one day before ovulation


				dateWorkingWith = dateWW.setDate(dateWW.getDate() - 1);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('veryFertileDay');
				} // two days before ovulation


				dateWorkingWith = dateWW.setDate(dateWW.getDate() - 1);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('veryFertileDay');
				} //
				// fertile days
				//
				// one day after ovulation


				dateWorkingWith = dateWW.setDate(dateWW.getDate() + 3);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('fertileDay');
				} // three days before ovulation


				dateWorkingWith = dateWW.setDate(dateWW.getDate() - 4);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('fertileDay');
				} // four days before ovulation


				dateWorkingWith = dateWW.setDate(dateWW.getDate() - 1);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('fertileDay');
				} // five days before ovulation


				dateWorkingWith = dateWW.setDate(dateWW.getDate() - 1);
				var daysArray = document.querySelectorAll('.c-ovulation-cal__wrap-2 div[data-time="' + dateWorkingWith + '"]');

				for (var i = 0; i < daysArray.length; i++) {
				daysArray[i].classList.add('fertileDay');
				} // resetting the date for next period (currently on -14, with ovulation lenght already added)


				dateWorkingWith = dateWW.setDate(dateWW.getDate() + 19);
			}
		}, 100);
	}
}
